import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignHorizontalCentre12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowAlignHorizontalCentre12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ArrowAlignHorizontalCentre12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.5.5a.5.5 0 0 0-1 0v2.663L4.233 1.896a.5.5 0 1 0-.707.708l2.122 2.12.353.354.354-.353 2.121-2.121a.5.5 0 1 0-.707-.708L6.5 3.166zM1 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 1 6m5.002 6.078a.5.5 0 0 1-.5-.5V8.913l-1.269 1.269a.5.5 0 0 1-.707-.707l2.122-2.121L6 7l.354.354 2.121 2.12a.5.5 0 0 1-.707.708L6.502 8.915v2.663a.5.5 0 0 1-.5.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ArrowAlignHorizontalCentre12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconArrowAlignHorizontalCentre12);
